import { useState } from "react";
import { redFlagGroups } from "../data";

export default function RedFlags() {
  const [active, setActive] = useState(redFlagGroups[0].key);

  const current = redFlagGroups.find((g) => g.key === active) ?? redFlagGroups[0];

  return (
    <section id="redFlags" className="scroll-mt-20 bg-foreground-950">
      <div className="site-container py-12 md:py-16">
        <div className="flex flex-col items-center text-center gap-3 mb-10">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-500/90 px-4 py-1.5 text-xs font-semibold tracking-widest text-background-50 whitespace-nowrap">
            <i className="ri-alarm-warning-line text-sm w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
            危险信号 · 前兆分析
          </span>
          <h2 className="text-2xl md:text-4xl leading-snug text-background-50">
            别等官宣，这些<span className="text-accent-300">前兆</span>早就出现了
          </h2>
          <p className="max-w-2xl text-sm md:text-base leading-relaxed text-background-200/85">
            单个信号或许只是巧合，多个信号叠加才是值得警惕的预警。切换到不同维度，逐条对照你关注的对象。
          </p>
        </div>

        <div
          className="flex flex-wrap items-center justify-center gap-2 p-1 rounded-full border border-background-200/20 bg-background-50/5 mb-8"
          role="tablist"
          aria-label="危险信号分类"
        >
          {redFlagGroups.map((g) => {
            const isActive = active === g.key;
            return (
              <button
                key={g.key}
                type="button"
                role="tab"
                aria-selected={isActive}
                onClick={() => setActive(g.key)}
                className={`inline-flex items-center gap-2 rounded-full px-4 md:px-5 py-2 text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                  isActive
                    ? "bg-accent-500 text-foreground-950"
                    : "text-background-100/85 hover:bg-background-50/10"
                }`}
              >
                {g.title}
              </button>
            );
          })}
        </div>

        <div className="rounded-lg border border-background-200/20 bg-background-50/5 p-5 md:p-6">
          <div className="flex items-center justify-between gap-3 border-b border-background-200/15 pb-4 mb-5">
            <div>
              <h3 className="text-base md:text-lg font-bold text-accent-300">{current.title}</h3>
              <p className="mt-1 text-xs md:text-sm text-background-200/75">{current.sub}</p>
            </div>
            <span className="flex items-center justify-center w-10 h-10 rounded-md bg-primary-500 text-background-50 shrink-0">
              <i className="ri-scan-line text-xl w-5 h-5 flex items-center justify-center" aria-hidden="true"></i>
            </span>
          </div>

          <ul className="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-4">
            {current.items.map((item, i) => (
              <li
                key={item.title}
                className="flex gap-3 rounded-md bg-background-50/[0.04] p-4 border-l-2 border-accent-500"
              >
                <span className="font-serif text-lg font-bold text-primary-400 leading-none shrink-0">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div>
                  <h4 className="text-sm md:text-[15px] font-bold text-background-50">{item.title}</h4>
                  <p className="mt-1 text-xs md:text-sm leading-relaxed text-background-200/80">{item.sig}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <p className="mt-6 flex items-center justify-center gap-2 text-xs text-background-200/70">
          <i className="ri-error-warning-line text-sm w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
          以上内容为通用风险观察维度，仅供参考，不针对任何具体个人或事件
        </p>
      </div>
    </section>
  );
}